// extracted by mini-css-extract-plugin
export default {"root":"view-only-name_root__hF+-i","name":"view-only-name_name__xpFLj","label":"view-only-name_label__ryQLw","icon":"view-only-name_icon__VIYnQ"};